import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "achievement" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "lv" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item item2" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "lvList" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "describe" }
const _hoisted_10 = { class: "progress" }
const _hoisted_11 = { class: "minMax" }
const _hoisted_12 = { class: "num" }

import {ref, reactive,watch} from 'vue';
import {useStore} from 'vuex'
import { getUserLevelDetail} from '@/service';
import { $enum } from '@/global'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  sceneId:{
    required: true,
    type: String,
    default: '',
  },
  sceneTypeId:{
    required: true,
    default: 0,
  },
  courseTypeId:{
    required: true,
    type: String,
    default: '',
  },
},
  setup(__props, { expose: __expose }) {

const props = __props;
const store = useStore();
const showModel = ref(false);
const state = reactive({
  lvList:[
    {
      lv:1,
      status:0,
      describe:'',
      total:1,
      progress:0,
    },
    {
      lv:2,
      status:0,
      describe:'',
      total:0,
      progress:0,
    },
    {
      lv:3,
      status:0,
      describe:'',
      total:0,
      progress:0,
    },
    {
      lv:4,
      status:0,
      describe:'',
      total:0,
      progress:0,
    },
    {
      lv:5,
      status:0,
      describe:'',
      total:0,
      progress:0,
    },
  ],
  currentLevel:0,
})

watch(showModel,async(newValue)=>{
  if(newValue){
    try {
      const res = await getUserLevelDetail({
        userId: store.state.persistence.userInfo.userId,
        tenantId:store.state.persistence.currentTenantId,
        sceneId:props.sceneId,
        sceneTypeId:props.sceneTypeId
      })
      if(res.code == $enum.EnumResult.SUCCESS){
        const {
          currentLevel,
          level1MaxNum,
          level1UserNum,
          level2MaxNum,
          level2UserNum,
          level3MaxNum,
          level3UserNum,
          level4MaxNum,
          level4UserNum,
          level5MaxNum,
          level5UserNum,
          level1Description,
          level2Description,
          level3Description,
          level4Description,
          level5Description
        } = res.data as any;
        state.lvList[0].progress = level1UserNum;
        state.lvList[0].total = level1MaxNum;
        state.lvList[0].status =  currentLevel>=1?1:0;
        state.lvList[0].describe = level1Description;
        state.lvList[1].progress = level2UserNum;
        state.lvList[1].total = level2MaxNum;
        state.lvList[1].describe = level2Description;
        state.lvList[1].status =  currentLevel>=2?1:0;
        state.lvList[2].progress = level3UserNum;
        state.lvList[2].total = level3MaxNum;
        state.lvList[2].describe = level3Description;
        state.lvList[2].status =  currentLevel>=3?1:0;
        state.lvList[3].progress = level4UserNum;
        state.lvList[3].total = level4MaxNum;
        state.lvList[3].describe = level4Description;
        state.lvList[3].status =  currentLevel>=4?1:0;
        state.lvList[4].progress = level5UserNum;
        state.lvList[4].total = level5MaxNum;
        state.lvList[4].describe = level5Description;
        state.lvList[4].status =  currentLevel>=5?1:0;
        state.currentLevel = currentLevel;
      }
    } catch (error) {
      console.log(error,"出错了")
    }
  }
})

function getLvIcon(item: { lv: number; status: number }) {
  let name = '';
  if(props.courseTypeId == $enum.CourseTypeEnum.电力巡检){
    name = item.status === 1
      ? `lv${item.lv}_${props.courseTypeId}_${item.status}`
      : `lv${item.lv}`
  }else{
    name = item.status === 1
      ? `lv${item.lv}_${props.sceneTypeId}_${item.status}`
      : `lv${item.lv}`
  }
  return require(`@/assets/images/${name}.png`)
}

const setProgressStyle = (item:any) => {
  const result = item.total && item.progress / item.total || 0;
  return { 
    width: `${result * 100}%`,
  }
}
function handleClose(){
  window?.playClick()
  showModel.value = false;
}
function handleCancle(){
  window?.playClick()
  showModel.value = false;
}
function handleConfirm(){
  window?.playClick()
  showModel.value = false;
}
__expose({showModel})

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!

  return _withDirectives((_openBlock(), _createBlock(_component_vkm_modal, {
    title: "我的成就",
    onOnClose: handleClose,
    isFooter: false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, " 当前等级 ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(state.currentLevel===0 || state.currentLevel===1?'':`Lv.${state.currentLevel-1}`), 1),
            _createElementVNode("div", _hoisted_5, "Lv." + _toDisplayString(state.currentLevel), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(state.currentLevel===5?'':`Lv.${state.currentLevel+1}`), 1)
          ]),
          _createVNode(_component_vkm_svg, {
            "icon-name": "lvLine",
            class: "lvLine"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", {
            class: "title",
            style: {"margin-top":"40px"}
          }, " 等级规则 ", -1)),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lvList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index
              }, [
                _createElementVNode("img", {
                  src: getLvIcon(item),
                  class: "icon",
                  alt: ""
                }, null, 8, _hoisted_8),
                _createElementVNode("div", {
                  class: _normalizeClass(item.status?'status status2':'status')
                }, _toDisplayString(!item.status?'未达成':'已完成'), 3),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.describe), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: "num",
                    style: _normalizeStyle(setProgressStyle(item))
                  }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "num" }, "0", -1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(`${item.progress}/${item.total}`), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 512)), [
    [_vShow, showModel.value]
  ])
}
}

})